import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';

import { GlobalStyle } from './styles/GlobalStyle';
import { GlobalProvider } from './context/globalContext';

const root = ReactDOM.createRoot(
    document.getElementById('root')
);

root.render(
    <React.StrictMode>
        <GlobalStyle />

        <GlobalProvider>
            <App />
        </GlobalProvider>
    </React.StrictMode>
);